export type PasswordStrength = {score: 0 | 1 | 2 | 3 | 4};

export function getPasswordStrength(pwd: string): PasswordStrength {
  if(!pwd.trim()) return {score: 0};
  let score = 0;
  if(pwd.length >= 6) score++;
  if(pwd.length >= 10) score++;
  if(/[a-z]/.test(pwd) && /[A-Z]/.test(pwd)) score++;
  if(/\d/.test(pwd)) score++;
  if(/[^a-zA-Z0-9]/.test(pwd)) score++;
  return {score: Math.min(4, score) as 0 | 1 | 2 | 3 | 4};
}
